import {
  Table,
  TableColumn,
  Progress,
  ResponseErrorPanel,
  Content,
  Page,
  Link,
  Breadcrumbs,
  Header,
  HeaderLabel,
} from '@backstage/core-components';
import useAsync from 'react-use/lib/useAsync';
import { Grid } from '@material-ui/core';
import { EventsMap, drEventTaxonomyReferenceDataProxyApiRef } from '../../api';
import { useApi } from '@backstage/core-plugin-api';
import { BadResponse } from './BadResponse';

type DenseTableProps = {
  events: EventsMap;
};

export const DenseTable = ({ events }: DenseTableProps) => {
  const columns: TableColumn[] = [
    { title: 'Event Name', field: 'event' },
    { title: 'Event Owner', field: 'owner' },
    { title: 'Description', field: 'description' },
  ];

  const data: any[] = [];
  Object.keys(events).forEach(key => {
    const event = events[key];
    const eventName = event.name.replace('Event', '');
    const finalEventName = eventName.charAt(0).toLowerCase() + eventName.slice(1);
    data.push({
      event: (
        <Link to={`/dr-event-taxonomy-reference-data/events/${finalEventName}`} underline="always">
          {finalEventName}
        </Link>
      ),
      description: event.data_reliability_metadata.event_description.at(0) || 'Event Description not provided',
      eventName: finalEventName,
      owner: event.data_reliability_metadata.owning_org
        .map(owner => {
          return owner.charAt(0).toUpperCase() + owner.slice(1);
        })
        .join(', '),
    });
  });

  return (
    <Page themeId="tool">
      <Header
        title="Event Taxonomy Reference Data (ETRD)"
        subtitle="Streamline feature tracking with event taxonomy-related guidance"
      >
        <HeaderLabel label="Owner" value="Data Reliability" />
        <HeaderLabel label="Slack" value="#data-reliability" />
      </Header>
      <Content>
        <Grid container direction="column" spacing={3}>
          <Grid item>
            <Breadcrumbs>
              <Link to="/dr-event-taxonomy-reference-data">Home</Link>
            </Breadcrumbs>
          </Grid>
          <Grid item>
            <Table
              title="Events"
              options={{ search: true, paging: false, sorting: true }}
              columns={columns}
              data={data.sort((a, b) => (a.eventName > b.eventName ? 1 : -1))}
            />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};

export const EventsComponent = ({ mockData }: any) => {
  const apiClient = useApi(drEventTaxonomyReferenceDataProxyApiRef);
  const { value, loading, error } = useAsync(async () => {
    if (mockData !== undefined) {
      return mockData.data;
    }

    return apiClient.get<EventsMap>('digital-analytics-tracking-validator/v1/event');
  }, []);

  if (loading) {
    return <Progress />;
  } else if (error) {
    return <ResponseErrorPanel error={error} />;
  } else if (value instanceof Response) {
    return <BadResponse response={value} />;
  }

  return <DenseTable events={value || {}} />;
};
